// extracted by mini-css-extract-plugin
export default {"carrier":"CarrierImage_carrier__giQJG"};